import { createUseStyles } from 'react-jss'
import Card from '../../Card'
import { Link } from 'react-router-dom'
import { Colors } from '../../../constants/colors'
import { AmlFlaggedCompanyListItemModel } from '../../../redux/companyMonitorTypes'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons'

interface Props {
    customers: AmlFlaggedCompanyListItemModel[]
}

const AmlFlaggedCustomerList = ({ customers }: Props) => {
  const styles = useStyles()

  const renderHeader = () => {
    return (
      <Card className={`${styles.container} ${styles.header} card`}>
      <div className={styles.cell}>
        <h6>Name</h6>
      </div>
      <div className={styles.cell}>
        <h6>Company registration number</h6>
      </div>
      <div className={styles.cell}>
        <h6>Sanction</h6>
      </div>
      <div className={styles.cell}>
        <h6>State</h6>
      </div>
    </Card>
    )
  }

  const renderListItems = () => {
    return customers?.map((item, index) => {
      return (
        <Link key={`companyListItem${index}`} to={{pathname: `/aml/companies/${item.id}`}}>
          <Card className={`${styles.container} card`}>
            <div className={styles.cell}>
              {item.name}
            </div>
            <div className={styles.cell}>
              {item.companyRegistrationNumber}
            </div>
            <div className={styles.cell}>
              {item.isSanction &&
              <FontAwesomeIcon
                icon={faExclamationTriangle}
                color={Colors.yellow}
                title='Sanction flag set'
              />
              }
            </div>
            <div className={styles.cell}>
              <span className={styles.badge} style={{backgroundColor: item.state === 'flagged' ? Colors.rubel_100 : Colors.dollar_100}}>
                {item.state}
              </span>
            </div>
          </Card>
        </Link>
      )
    })
  }

  return (
    <div>
       {renderHeader()}
       {renderListItems()}
    </div>
  )
}

export default AmlFlaggedCustomerList

const useStyles = createUseStyles({
  container: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    textAlign: 'left',
    padding: '3px 20px',
    margin: '10px 0',
    transition: '0.4s',
    '&:hover': {
      backgroundColor: Colors.darkGrayHover,
    }
  },
  header: {
    margin: '30px 0 20px 0',
  },
  cell: {
    flex: 1
  },
  badge: {
    textAlign: 'center',
    textTransform: 'capitalize',
    borderRadius: 5,
    padding: '2px 5px',
    backgroundColor: Colors.darkGray3,
    fontFamily: 'Aestetico-Regular',
    color: Colors.darkGray4,
    fontSize: 14,
  },
  pagination: {
    marginTop: 10,
    display: 'flex',
    justifyContent: 'center'
  }
})
